import axiosBackEnd from "../config/axios/axios-back-end";

const getHmgs = async () => {
  const res = await axiosBackEnd.get(`/api/hmgs`);
  return res.data;
};

const getHmg = async (id) => {
  const res = await axiosBackEnd.get(`/api/hmgs/${id}`);
  return res.data;
};

const getHmgProjectLists = async (id) => {
  const res = await axiosBackEnd.get(`/api/hmgs/${id}/projects`);
  return res.data;
};

const getHMGData = async () => {
  const url = `/api/hmg`;
  const response = await axiosBackEnd.get(url);

  return response.data.data;
};

const getRolesMappedToHMG = async (id) => {
  const res = await axiosBackEnd.get(`/api/hmg-main/role-mapping?hmg_id=${id}`);
  return res.data;
};

export { getHmgs, getHmg, getHmgProjectLists, getRolesMappedToHMG, getHMGData };
